import React, { FC, useRef, useEffect } from "react";
import { Styled } from "./SortOptionsMenu.styled";
import { useAppSelector } from "../../app/hooks";
import { handleSort } from "@sdge-store/overlaps/overlaps.slice";
import { SortOptionsItem, SelectSort } from "./components";
import { selectOverlaps } from "@sdge-store/overlaps/overlaps.selector";
import { sortOverlapsData } from "@sdge-store/overlaps/overlaps.async";

const OverlapsSortOptionsMenu: FC = () => {
  const { sort, columnDefs, filteringRules, searchInputValue } =
    useAppSelector(selectOverlaps);
  const listEnd = useRef<any>();
  const scrollToBottom = () => {
    listEnd.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [sort.length]);
  const unsortedCols = (columnDefs as any[])
    .filter(({ headerName }) => headerName)
    .filter(({ sorting }) => sorting)
    .filter((o1) => !sort.some((o2: any) => o1.field === o2.property));

  const sortingCols = unsortedCols
    .map((item, index) => {
      return { id: index, value: item.field, label: item.headerName };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
  return (
    <Styled.SortOptionsWrapper>
      <Styled.SortOptionsList>
        {(sort as any[]).map((item, index) => (
          <SortOptionsItem
            key={item.property}
            field={item.property}
            order={item.direction}
            index={index}
            columnDefs={columnDefs}
            sort={sort}
            filteringRules={filteringRules}
            searchInputValue={searchInputValue}
            handleSort={handleSort}
            sortData={sortOverlapsData}
          />
        ))}
        <Styled.ListBottom ref={listEnd}></Styled.ListBottom>
      </Styled.SortOptionsList>
      <Styled.SelectSortWrapper>
        {sortingCols.length > 0 && (
          <SelectSort
            placeHolder="Add field to sort by"
            optionsData={sortingCols}
            order="ASC"
            sort={sort}
            filteringRules={filteringRules}
            searchInputValue={searchInputValue}
            handleSort={handleSort}
            sortData={sortOverlapsData}
          />
        )}
      </Styled.SelectSortWrapper>
    </Styled.SortOptionsWrapper>
  );
};

export default OverlapsSortOptionsMenu;
